'use client';

import { signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { useToggle } from 'usehooks-ts';

import { Button } from '../ui/Button';

export type SignInButtonClientProps = {
  readonly translationKey:
    | 'signin_sso_login_button'
    | 'signin_email_login_button';
  readonly signInParams?: Parameters<typeof signIn>[2];
};

const SignInButtonClient = ({
  translationKey,
  signInParams,
}: SignInButtonClientProps) => {
  const t = useTranslations();
  const [isLoading, toggleLoading] = useToggle();

  return (
    <Button
      loading={isLoading}
      onClick={(e) => {
        e.preventDefault();
        toggleLoading();
        void signIn('moi', undefined, signInParams);
      }}
      data-testid="email-sign-in-button"
    >
      {t(translationKey)}
    </Button>
  );
};

export default SignInButtonClient;
